/**
 * cmsApi — thin auth-aware wrapper around /api/cms/pages/*.
 */
const BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api/cms/pages`;

function _headers() {
  const t = localStorage.getItem("sp_token") || localStorage.getItem("token") || "";
  return { "Content-Type": "application/json", ...(t ? { Authorization: `Bearer ${t}` } : {}) };
}

async function _handle(r) {
  if (!r.ok) {
    let msg = `Request failed (${r.status})`;
    try { const j = await r.json(); msg = j.detail || msg; } catch {}
    throw new Error(msg);
  }
  return r.json();
}

export const cmsApi = {
  publicPage: (portal, slug) => fetch(`${BASE}/public/${encodeURIComponent(portal)}/${slug}`).then(_handle),
  list:       ({ portal_slug, status } = {}) => {
    const p = new URLSearchParams();
    if (portal_slug) p.set("portal_slug", portal_slug);
    if (status)      p.set("status", status);
    return fetch(`${BASE}/admin?${p}`, { headers: _headers() }).then(_handle);
  },
  read:   (id)      => fetch(`${BASE}/admin/${id}`,   { headers: _headers() }).then(_handle),
  create: (body)    => fetch(`${BASE}/admin`,         { method: "POST", headers: _headers(), body: JSON.stringify(body) }).then(_handle),
  update: (id, body) => fetch(`${BASE}/admin/${id}`,   { method: "PUT",  headers: _headers(), body: JSON.stringify(body) }).then(_handle),
  remove: (id)      => fetch(`${BASE}/admin/${id}`,   { method: "DELETE", headers: _headers() }).then(_handle),
};

export default cmsApi;
